import { SubscriptionStatus } from './constants'

export function isSmsSubscribed(smsSubscriptionStatus) {
  return smsSubscriptionStatus === SubscriptionStatus.SUBSCRIBED
}
